import { resetState } from '@redux/ducks/global';

export function ReduxActions($ngRedux) {
  'ngInject';

  return {
    resetGlobalState,
  };

  function resetGlobalState() {
    $ngRedux.dispatch(resetState());
  }
}
